import { render, staticRenderFns } from "./GrniList.vue?vue&type=template&id=05aee0a7&scoped=true&"
import script from "./GrniList.vue?vue&type=script&lang=js&"
export * from "./GrniList.vue?vue&type=script&lang=js&"
import style0 from "./GrniList.vue?vue&type=style&index=0&id=05aee0a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aee0a7",
  null
  
)

export default component.exports